import React from 'react';
import { motion } from 'framer-motion';
import { Target, Eye } from 'lucide-react';

const MissionVision = () => {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0d1f33]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-white">Our</span>{' '}
            <span className="text-[#EFCD86]">Mission & Vision</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 0.6 }}
            className="group flex flex-col bg-white/5 backdrop-blur-md rounded-2xl overflow-hidden border border-white/10 shadow-2xl"
          >
            <div className="w-full h-64 md:h-80 relative overflow-hidden">
              <img 
                src="/assest/missionvision/mission.png" 
                alt="Our Mission" 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0e3a63] to-transparent opacity-60"></div>
            </div>
            <div className="p-8 relative border-t-4 border-[#EFCD86] flex-grow flex flex-col justify-center bg-[#0d1f33]/80">
              <div className="flex items-center gap-4 mb-6 relative z-10">
                <div className="w-12 h-12 rounded-full bg-[#EFCD86] flex items-center justify-center shadow-[0_0_15px_rgba(239,205,134,0.4)]">
                  <Target size={24} className="text-[#0a1628]" />
                </div>
                <h3 className="text-3xl font-bold text-white">Our Mission</h3>
              </div>
              <p className="text-gray-300 text-lg leading-relaxed relative z-10">
                Providing professional, high quality, reliable and efficient Software Solutions while maintaining ease and simplicity of usage for all.
              </p>
            </div>
          </motion.div>

          {/* Vision */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="group flex flex-col bg-white/5 backdrop-blur-md rounded-2xl overflow-hidden border border-white/10 shadow-2xl"
          >
            <div className="w-full h-64 md:h-80 relative overflow-hidden">
              <img 
                src="/assest/missionvision/vision.png" 
                alt="Our Vision" 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0e3a63] to-transparent opacity-60"></div>
            </div>
            <div className="p-8 relative border-t-4 border-[#046A8C] flex-grow flex flex-col justify-center bg-[#0d1f33]/80">
              <div className="flex items-center gap-4 mb-6 relative z-10">
                <div className="w-12 h-12 rounded-full bg-[#046A8C] flex items-center justify-center shadow-[0_0_15px_rgba(4,106,140,0.4)]">
                  <Eye size={24} className="text-white" />
                </div>
                <h3 className="text-3xl font-bold text-white">Our Vision</h3>
              </div>
              <p className="text-gray-300 text-lg leading-relaxed relative z-10">
                Leading the software industry and guiding users to the new generation of online Business.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;